<template>
  <div class="footer">
    <p>闽网文【2018】2592-119号</p>
    <p>ICP证川B2-20211792 蜀ICP备2021023869号-1</p>
    <p>
      <a href="https://law.qingcigame.com/zh-cn/privacy_policy.html">隐私政策</a> |
      <a href="https://law.qingcigame.com/zh-cn/service_agreement.html">用户协议</a>
    </p>
    <p>开发者QcplayDigitalCo.,Ltd.</p>
    <p>Copyright©2020-2022 QCPLAY</p>
    <p>成都青瓷互动网络科技有限公司 版权所有</p>
    <p><span><img src="https://static.qcplay.com/common/police.png">川公网安备 51019002004205号</span></p>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  components: {},
  created () {},
  data () {
    return {};
  }
};
</script>
<style lang="less" scoped>
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/components/BankFooter/index.vue